<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('produitFace.onglet.affectation')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class='column is-narrow'>
          <date-picker :dates='dates' @recherche="getAffectationByType"/>
        </div>

        <div class="column is-4">
          <b-input :placeholder="$t('produitFace.actions.search')"
                   v-model="text"
                   type="search"
                   icon="magnify"
                   class="inputSearch">
          </b-input>
        </div>
      </div>
      <div>
        <p class="has-text-default has-text-weight-bold">
          {{ $t('produitFace.affectation.nbResultat',
          { nb: this.listAffectationFiltered.length }) }}
        </p>
        <hr class="mgt-20px mgb-20px">
        <div v-for="(affectation, index) in listAffectationFiltered" :key="index">
          <div class="columns">
            <div class="column is-3">
              <p class="has-text-link has-text-weight-bold is-size-5">{{ affectation.libelle }}</p>
              <p class="is-size-7 has-text-default"
                 v-if="!isRegroupementTempo">
                {{ $t('produitFace.affectation.duAu',
                { debut: getDateFormat(affectation.dureeAffectation.dateDebut),
                  fin: getDateFormat(affectation.dureeAffectation.dateFin) }) }}</p>
              <p class="is-size-7 has-text-default" v-else>
                {{ $t('produitFace.affectation.duAuWeek',
                { debut: getDateFormat(getDateDebutOfWeek(affectation.anneSemaine)),
                  fin: getDateFormat(getDateFinWeek(affectation.anneSemaine)),
                  week: affectation.anneSemaine.toString().substring(4, 6),
                  year: affectation.anneSemaine.toString().substring(0, 4)}) }}
              </p>
            </div>
            <div class="column is-2 mgv-auto">
                <routerLinkBlank :to="{ name: (getInformationDirection(affectation)).routeName,
                params: { id: (getInformationDirection(affectation)).id } }"
                                 :message="(getInformationDirection(affectation)).message">
                </routerLinkBlank>
            </div>
            <div class="column is-2 mgv-auto"
                 v-if="affectation.typeReference !== constantes.AFFECTATION_RESEAU">
              <span class="has-text-default">
                {{ !isRegroupementTempo ?
                $t('produitFace.affectation.montantLoc') :
                $t('produitFace.affectation.montantFace') }}
              </span>
              <span v-if="!isRegroupementTempo"
                    class="has-text-weight-bold">
                {{ affectation.montantLocation | formatDevise }}
              </span>
              <span v-else
                    class="has-text-weight-bold">
                {{ affectation.montantFace | formatDevise }}
              </span>
            </div>
            <div class="column is-2 mgv-auto"
                 v-if="affectation.typeReference !== constantes.AFFECTATION_RESEAU">
              <span class="has-text-default" v-if="!(isRegroupementTempo || isRegroupementLc)">
                {{ $t('produitFace.affectation.surfaceVendue') }}
              </span>
              <span class="has-text-weight-bold" v-if="!(isRegroupementTempo || isRegroupementLc)">
                {{ (affectation.quantiteDispo * 100)| formatPercent }}
              </span>
            </div>
          </div>
          <hr class="mgt-20px mgb-20px"
              v-if="index + 1 !== listAffectationFiltered.length">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import messageErreur from '@/services/general/messageErreur';
import {
  getAffectationProduitUnitaireAsync, getAffectationProduitReseauTempo,
  getAffectationProduitReseauMairie, getAffectationProduitReseauLc,
  getAffectationEcranNumerique, getAffectationReseauNumerique,
}
  from '@/api/affectation/index';
import formatIsoDate from '@/services/general/formatIsoDate';
import formatDate from '@/services/general/formatDate';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import inProgress from '@/services/general/inProgress';
import getAllWeekNumberDuringPeriode from '@/services/general/getAllWeekNumberDuringPeriode';
import {
  CATEGORIE_REGROUPEMENT_LC, CATEGORIE_REGROUPEMENT, CATEGORIE_UNITAIRE,
  AFFECTATION_RESEAU, CATEGORIE_ECRAN_NUMERIQUE, CATEGORIE_REGROUPEMENT_NUMERIQUE,
  CATEGORIE_REGROUPEMENT_MAIRIE,
} from '@/configuration/catalogue/produitConf';
import { TYPE_COMMANDE, TYPE_DEVIS } from '@/configuration/devisConf';
import { DATE_MAX, DATE_MIN } from '@/configuration/general/dateConf';
import datePicker from '@/components/general/datePicker';

export default {
  name: 'CatalogueAffectation',
  props: {
    produit: {
      type: Object,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
    datePicker,
  },
  data() {
    return {
      dates: {
        dateDebut: moment().subtract(2, 'y').toDate(),
        dateFin: null,
      },
      affectations: [],
      text: '',
      constantes: {
        AFFECTATION_RESEAU,
      },
    };
  },
  methods: {
    getInformationDirection(affectation) {
      if (affectation.typeReference === TYPE_COMMANDE) {
        return { routeName: 'c.bodac.commandes', id: affectation.referenceId, message: affectation.codeReference };
      }
      if (affectation.typeReference === TYPE_DEVIS) {
        return { routeName: 'c.bodac.devis', id: affectation.referenceId, message: affectation.codeReference };
      }
      if (affectation.typeReference === TYPE_COMMANDE) {
        return { routeName: 'c.bodac.commandes', id: affectation.referenceId, message: affectation.codeReference };
      }
      if (affectation.typeReference === AFFECTATION_RESEAU) {
        if (affectation.sousTypeReference === CATEGORIE_REGROUPEMENT) {
          return { routeName: 'c.bodac.catalogue-reseau', id: affectation.referenceId, message: this.$i18n.t('produitFace.affectation.viewReseau') };
        }
        if (affectation.sousTypeReference === CATEGORIE_REGROUPEMENT_NUMERIQUE) {
          return { routeName: 'c.bodac.catalogue-reseauNumerique', id: affectation.referenceId, message: this.$i18n.t('produitFace.affectation.viewReseau') };
        }
        if (affectation.sousTypeReference === CATEGORIE_REGROUPEMENT_LC) {
          return { routeName: 'c.bodac.catalogue-reseauLc', id: affectation.referenceId, message: this.$i18n.t('produitFace.affectation.viewReseau') };
        }
      }
      return { routeName: '', id: null, message: '' };
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getDateFormat(date) {
      return formatDate(date);
    },
    getDateDebutOfWeek(weekNumber) {
      return moment().year(Number(weekNumber.toString().substring(0, 4)))
        .week(Number(weekNumber.toString().substring(4, 6))).startOf('week');
    },
    getDateFinWeek(weekNumber) {
      return moment().year(Number(weekNumber.toString().substring(0, 4)))
        .week(Number(weekNumber.toString().substring(4, 6))).endOf('week');
    },
    async getAffectationRegroupement() {
      this.affectations = (await getAffectationProduitReseauTempo([{
        id: this.produit.id,
        anneeSemaines: getAllWeekNumberDuringPeriode(this.dates.dateDebut, this.dates.dateFin),
      }], null, true)).data.result[this.produit.id];
    },
    async getAffectationUnitaire() {
      this.affectations = (await getAffectationProduitUnitaireAsync(
        this.getFormatageParameterGeneral(), true, true,
      )).data.result[this.produit.id];
    },
    async getAffectationRegroupementLc() {
      this.affectations = (await getAffectationProduitReseauLc(
        this.getFormatageParameterGeneral(), true,
      )).data.result[this.produit.id];
    },
    async getAffectationRegroupementMairie() {
      this.affectations = (await getAffectationProduitReseauMairie(
        this.getFormatageParameterGeneral(), true,
      )).data.result[this.produit.id];
    },
    async getAffectationRegroupementNumerique() {
      this.affectations = (await getAffectationReseauNumerique(
        this.getFormatageParameterGeneral(), true,
      )).data.result[this.produit.id];
    },
    async getAffectationEcranNumerique() {
      this.affectations = (await getAffectationEcranNumerique(
        this.getFormatageParameterGeneral(), true,
      )).data.result[this.produit.id];
    },
    getFormatageParameterGeneral() {
      return [{
        id: this.produit.id,
        dureeAffectation: {
          dateDebut: formatIsoDate(this.dates.dateDebut ? this.dates.dateDebut : DATE_MIN),
          dateFin: formatIsoDate(this.dates.dateFin ? this.dates.dateFin : DATE_MAX),
        },
      }];
    },
    async getAffectationByType() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        switch (this.produit.supportCommercial.categorieVente) {
          case CATEGORIE_UNITAIRE:
            await this.getAffectationUnitaire();
            break;
          case CATEGORIE_REGROUPEMENT:
            await this.getAffectationRegroupement();
            break;
          case CATEGORIE_REGROUPEMENT_LC:
            await this.getAffectationRegroupementLc();
            break;
          case CATEGORIE_REGROUPEMENT_MAIRIE:
            await this.getAffectationRegroupementMairie();
            break;
          case CATEGORIE_REGROUPEMENT_NUMERIQUE:
            await this.getAffectationRegroupementNumerique();
            break;
          case CATEGORIE_ECRAN_NUMERIQUE:
            await this.getAffectationEcranNumerique();
            break;
          default:
            this.inProgress();
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    isRegroupementTempo() {
      return this.produit.supportCommercial.categorieVente === CATEGORIE_REGROUPEMENT;
    },
    isRegroupementLc() {
      return this.produit.supportCommercial.categorieVente === CATEGORIE_REGROUPEMENT_LC;
    },
    listAffectationFiltered() {
      return this.affectations
        .filter((affectation) => {
          return affectation.libelle.toLowerCase().includes(this.text.toLowerCase());
        })
        .sort((a, b) => {
          const dateDebutA = this.produit.supportCommercial.categorieVente
          === CATEGORIE_REGROUPEMENT
            ? this.getDateDebutOfWeek(a.anneSemaine) : a.dureeAffectation.dateDebut;
          const dateDebutB = this.produit.supportCommercial.categorieVente
          === CATEGORIE_REGROUPEMENT
            ? this.getDateDebutOfWeek(b.anneSemaine) : b.dureeAffectation.dateDebut;
          if (moment(dateDebutA).isBefore(moment(dateDebutB))) return 1;
          return moment(dateDebutA).isAfter(moment(dateDebutB)) ? -1 : 0;
        });
    },
  },
  mounted() {
    this.getAffectationByType();
  },
};
</script>
